import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { DateFormatterService } from '@shared/services/date-formatter.service';
import { TableTemplateColumnConfig } from '@components/ui/table-template/models/table-template-column-config';
import { DataViewModel } from '@components/ui/table-template/models/data-view-model';
import { DataViewModelValue } from '@components/ui/table-template/models/data-view-model-value';

@Component({
    selector: 'app-table-cell-date-time',
    templateUrl: './table-cell-date-time.component.html',
    styleUrls: ['./table-cell-date-time.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableCellDateTimeComponent {
  private readonly dateFormatterService = inject(DateFormatterService);

  public readonly value = signal('');

  initialize(column: TableTemplateColumnConfig, row: DataViewModel, cell: DataViewModelValue): void {
    if (cell instanceof Date) {
      this.value.set(this.dateFormatterService.formatDateTime(cell));
    }
  }
}
